import React, { useEffect, useState } from 'react';
import CardBody from 'components/Card/CardBody';
import { BodyS, HeadingMBold } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import Card from 'components/Card/Card';
import styles from 'assets/jss/material-dashboard-pro-react/views/accounts/accountDetailsSubpageStyle';
import { makeStyles } from '@material-ui/core';
import { DepartmentsService } from 'services/departments/departments';
import { finalize } from 'rxjs/operators';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import CustomCircularProgress from 'components/CustomCircularProgress/CustomCircularProgress';
import SingleAccountManager from './SingleAccountManager';
import { SingleAccountManager as SingleManager } from 'utils/api/models/users/singleAccountManager';
import GridContainer from 'components/Grid/GridContainer';
import Logo from 'components/Logo/Logo';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IAccountManagersProps {
	documentId: string;
	documentType: types.organizations.documentType;
}

const AccountManagers = ({ documentId, documentType }: IAccountManagersProps) => {
	const classes = useStyles();
	const [loading, setLoading] = useState<boolean>(false);
	const [managers, setManagers] = useState<SingleManager[]>([]);

	useEffect(() => {
		setLoading(true);
		DepartmentsService.getAccountManagerDetails(documentId, documentType)
			.pipe(finalize(() => setLoading(false)))
			.subscribe(({ managers }) => setManagers(managers));
	}, [documentId, documentType]);

	return (
		<Card>
			<CardBody className={classes.accountManagersCardBody}>
				<div className={classes.logoWrapper}>
					<Logo size="rg" color="color" />
				</div>
				<HeadingMBold color="primary-light">{translate('account.details.account.managers')}</HeadingMBold>
				<ConditionalRender
					show={loading}
					onTrue={() => <CustomCircularProgress text={translate('loading')} loading={true} transparent />}
					onFalse={() => (
						<ConditionalRender
							show={managers?.length > 0}
							onTrue={() => (
								<GridContainer justify="flex-start">
									{(managers || []).map((singleManager, index) => (
										<SingleAccountManager key={index} manager={singleManager} />
									))}
								</GridContainer>
							)}
							onFalse={() => (
								<div>
									<BodyS color="secondary-light" disableMargin>
										{translate('organization.details.no.account.managers')}
									</BodyS>
								</div>
							)}
						/>
					)}
				/>
			</CardBody>
		</Card>
	);
};

export default AccountManagers;
